  import ldf from '../../localDataFunctions'
  import moment from 'moment';

  export default {
    name: 'StationDeclaredDialogs',
    mixins: [ldf],
    props: {
      createAppLabel: {
        required: true,
        type: Boolean
      },
      applicationStation: {
        default: null,
        type: String
      },
      showDialog: {
        required: false,
        type: Boolean
      }
    },
    data: function () {
      return {
        conscent: false,
        openDialog: false,
        stations: {},
        openedFromCreateApp: false,
        consentForNotDisplay: false,
        consentForNotDisplayTimeDate: '',
      }
    },
    computed: {
      label: function () {
        return this.compareStation ? this.$t('NotificationDialog.WarningTextApplication') : this.$t('NotificationDialog.WarningTextCreateApp');
      }
    },
    watch: {
      showDialog: function (val) {
        if (this.consentForNotDisplay) {
          let start = moment(this.consentForNotDisplayTimeDate);
          let today = moment();

          if (today.diff(start, 'days') >= 1) {
            this.openDialog = val;
            this.consentChanged(false);
          }            
        }
        else
          this.openDialog = val;        
      }
    },
    created() {
      this.stations = this.$store.getters.getUserStations;
      let data = this.getFromLocal('display_app_stations_warning');

      if (data) {
        let start = moment(this.consentForNotDisplayTimeDate);
        let today = moment();

        if (today.diff(start, 'days') >= 1) {
          this.consentChanged(false);
        }
        else {
          this.consentForNotDisplay = data.value == true;
          this.consentForNotDisplayTimeDate = data.date
        }
      }
      else
        this.consentChanged(false);
    },
    methods: {
      okButtonClicked() {
        this.openDialog = false;
      },
      consentChanged(val) {
        this.consentForNotDisplay = val;
        if(val)
          this.consentForNotDisplayTimeDate = moment().format();
        else
          this.consentForNotDisplayTimeDate = '';

        this.saveToLocal('display_app_stations_warning', { value: val, date: this.consentForNotDisplayTimeDate });
      }
    },
  }
